import React from "react"
import './adv.css'
import cloudinary from 'cloudinary-core'
import { Container } from "components/elements"
import { CLOUDINARY_NAME, CLOUDINARY_API_KEY } from "constants/images/cloudinary"
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

const BlogAdvertisement = (props) => {
  const { isMobile, mobileAdvertisement, desktopAdvertisement } = props

  return (
    <div className={`${isMobile ? 'blog-adv-mobile' : 'blog-adv'}`}>
      {!isMobile && desktopAdvertisement && (
        <a href={desktopAdvertisement.link} target="_blank">
          <img
            src={cl.url(
              desktopAdvertisement.image?.cloudinary_public_id
            )}
            alt="blog posts desktop adv" />
        </a>
      )}

      {isMobile && mobileAdvertisement && (
        <Container className="small">
          <a href={mobileAdvertisement.link} target="_blank">
            <img
              src={cl.url(
                mobileAdvertisement.image?.cloudinary_public_id
              )}
              alt="blog posts mobile adv" />
          </a>
        </Container>
      )}
    </div>
  )
}

export default BlogAdvertisement